import { Theme } from "@deere/fuel-react";
import { SxProps } from "@mui/material";
import { gridClasses } from "@mui/x-data-grid-pro";

export const generateGridDefaultStyles = (theme: Theme): SxProps => ({
  border: `1px solid ${theme.tokens.FuelColorBorderLight}`,
  [`.${gridClasses.overlayWrapper}`]: {
    height: "50vh",
    borderRadius: "10px",
  },
  [`.${gridClasses.overlayWrapperInner}`]: {
    height: "100% !important",
  },
  [`.${gridClasses.virtualScroller}`]: {
    overflow: "hidden",
    border: 0,
    overflowX: "scroll",
  },
  [`.${gridClasses.cell}`]: {
    padding: theme.tokens.FuelSpacing4,
    outline: "none !important",
    alignItems: "center",
    "&:focus": {
      outline: "none",
    },
    "&:focus-within": {
      outline: "none",
    },
    "& a svg": {
      marginTop: "auto",
      marginBottom: "auto",
    },
  },
  [`& .${gridClasses.row}`]: {
    maxHeight: "none !important",
    minHeight: "auto !important",
    borderBottom: `1px solid ${theme.tokens.FuelColorBorderLight}`,
    "&:last-child": {
      borderBottom: 0,
    },
    "& > .MuiDataGrid-cell:first-of-type": {
      padding: "16px 4px",
    },
  },
  [`& .${gridClasses.toolbarContainer} > button`]: {
    border: "none",
    color: theme.tokens.FuelColorBrandPrimary,
    boxShadow: "none",
    margin: theme.tokens.FuelSpacing4,
  },
  "& .MuiDataGrid-cell.MuiDataGrid-cellEmpty": {
    padding: 0,
  },
  [`& .${gridClasses.toolbarContainer}`]: {
    borderBottom: `1px solid ${theme.tokens.FuelColorBorderLight}`,
    height: "4.25rem",
  },
  [`& .${gridClasses.columnHeader}`]: {
    paddingLeft: theme.tokens.FuelSpacing4,
    "&:focus": {
      outline: "none",
    },
    "&:focus-within": {
      outline: "none",
    },
    "&:hover": {
      backgroundColor: theme.tokens.FuelColorGray50,
    },
    borderBottom: `1px solid ${theme.tokens.FuelColorBorderLight}`,
  },
  [`& .${gridClasses.columnSeparator}`]: {
    color: "transparent",
    transition: "color 0.2s",
  },
  [`& .${gridClasses.columnHeaders}:hover .${gridClasses.columnSeparator}`]: {
    color: theme.tokens.FuelColorBorderLight,
  },
  [`& .${gridClasses.columnHeaders}`]: {
    borderBottom: `1px solid ${theme.tokens.FuelColorBorderLight}`,
  },
  [`& .${gridClasses.columnHeaders} > div[role="row"]`]: {
    backgroundColor: theme.tokens.FuelColorBackgroundWhite,
  },
  [`& .${gridClasses.iconSeparator}`]: {
    display: "none",
  },
  [`& .${gridClasses.columnHeaderTitle}`]: {
    fontWeight: theme.tokens.FuelFontWeightSemibold,
    fontSize: theme.tokens.FuelFontSizeHeading6,
  },
  [`& .${gridClasses.columnHeader}--filledGroup`]: {
    backgroundColor: "transparent",
  },
});

export const reorderColumns = <T,>(
  list: T[],
  startIndex: number,
  endIndex: number
): T[] => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};
